import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IframeResizer from "iframe-resizer-react";
import postscribe from "postscribe";

class VotionBracket extends Component {

    static propTypes = {
        src: PropTypes.string.isRequired
    };

    state = {
        scriptsLoaded: false,
    };

    componentDidMount() {
        this.handleLoading();
    }

    handleLoading = () => {
        const element = document.getElementById('votionBracket');

        // Detect if Script is already loaded on the page to prevent duplicate loading.
        const scriptAlreadyLoaded = document.querySelector('script[src="https://bracket-v3.votion.co/bracket-widget.js.php"]');

        if (element && !this.state.scriptsLoaded) {
            if (!scriptAlreadyLoaded) postscribe('#votionBracket', '<script src="https://bracket-v3.votion.co/bracket-widget.js.php"></script>');
            this.setState({scriptsLoaded: true});
        }
    };

    render() {
        return (
            <div id="votionBracket" className="votionBracket">
                {this.state.scriptsLoaded ? (
                    <IframeResizer src={this.props.src} style={{border: 0, width: '100%'}}/>
                ) : null}
            </div>
        );
    }
}

export default VotionBracket;



// WEBPACK FOOTER //
// ./frontend/components/VotionBracket/VotionBracket.jsx